import './widget.scss';
import meal from '../../assets/img/icons/meal.svg';
import key from '../../assets/img/icons/keys.svg';

function Crisis() {
  return (
    <div className="widget asdf">
      <p className="widget__title">
        Since the beginning of the pandemic, The Salvation Army has provided more than
      </p>

      <div className="widget__split-box widget__split-box--no-border">
        <div>
          <img className="widget__icon" src={meal} alt="Meal" />
          <p className="widget__stat">278M</p>
          <p className="widget__text">meals</p>
        </div>
        <div>
          <img className="widget__icon" src={key} alt="Utilities" />
          <p className="widget__stat">+$200M</p>
          <p className="widget__text">utility, rent and mortgage assistance</p>
        </div>
      </div>
    </div>
  );
}

export default Crisis;
